import { useEffect, useRef } from 'react'

const useClusterChangeReload = (
  clusterName: unknown,
  reload: (refetch: boolean, updateLoadingState: boolean) => Promise<void>,
) => {
  const prevClusterRef = useRef<unknown>(undefined)

  useEffect(() => {
    if (prevClusterRef.current !== undefined && prevClusterRef.current !== clusterName) {
      reload(true, false)
    }
    prevClusterRef.current = clusterName
  }, [clusterName, reload])
}

export default useClusterChangeReload
